import React from 'react';
import ReactDOM from 'react-dom';
import Board from './Board';
import './index.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Board count={25} />,
  document.getElementById('react-container')
);

serviceWorker.register();
